/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `16:9` - 가로 (16:9)
 * `9:16` - 세로 (9:16)
 * `1:1` - 정사각형 (1:1)
 */
export type AspectRatioEnum =
  (typeof AspectRatioEnum)[keyof typeof AspectRatioEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AspectRatioEnum = {
  "16:9": "16:9",
  "9:16": "9:16",
  "1:1": "1:1",
} as const;
